import React, { useEffect, useState } from "react";
import jQuery from "jquery";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Spinner,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { MDBDataTableV5 } from "mdbreact";
import { useSelector } from "react-redux";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

// Require Font Awesome.
import "font-awesome/css/font-awesome.css";
import { BASE_URL } from "../utils/constants";
import axios from "axios";
import Swal from "sweetalert2";
import { RichBox } from "components/RichBoxComponent";

function GroupProjects() {
  const permissions = useSelector((state) => state.permissions);
  const [proId, setProId] = useState("");
  const [showAll, setShowAlll] = useState("");
  const [selectedPrefs, setSelectedPrefs] = useState({
    template: "Default",
    bgcolor: "#ffffff",
    fgcolor: "#000000",
  });
  const [modalPrefs, setModalPrefs] = useState(false);
  const [datatable, setDatatable] = useState({
      columns: [
        {
          label: "#",
          field: "serial",
        },
        {
          label: "ID",
          field: "projectid",
        },
        {
          label: "Project Name",
          field: "projectname",
        },

        {
          label: "Controls",
          field: "controls",
        },
      ],
      rows: [
        {
          serial: <Spinner color="info" />,
          projectid: <Spinner color="info" />,
          projectname: <Spinner color="info" />,
          controls: <></>,
        },
      ],
    }),
    [addProject, setAddProject] = useState("none"),
    [formData, setFormData] = useState({
      title: "",
    }),
    [descModal, setDescModal] = useState(false);
  const [richBox, setRichBox] = useState("");

  const clearFormData = () => {
    setFormData((prevState) => ({ ...prevState, title: "" }));
    setRichBox("");
  };

  useEffect(() => {
    (async () => {
      let res = [];
      Swal.showLoading();
      try {
        res = await axios.post(`${BASE_URL}/student/getgroupprojects.php`, {
          sId: permissions.id,
        });
       
        setDatatable((prevState) => {
          const newState = { ...prevState };
          let ser = 1;
          let newRows = res.data.data.groupprojects.map((proj, key) => {
            return {
              ...proj,
              serial: ser++,
              projectid: proj.id,
              projectname: proj.name,
              controls: (
                <>
                  <div className="row justify-content-start p-3">
                    <a
                      className="col-3 w-75 my-1 btn btn-info"
                      onClick={() => handleDescModal(proj)}
                    >
                      Show
                    </a>

                    <Link
                      className="col-3 w-75 my-1 btn btn-success fw-bolder col-2"
                      to={`/groupprojects/${proj.id}`}
                    >
                      Progress
                    </Link>

                    <a
                      className="col-3 w-75 my-1  btn btn-primary fw-bolder col-2"
                      onClick={(e) => handlePrefs(e, proj.id)}
                    >
                      Preferences
                    </a>

                    <a
                      className="col-3 w-75 my-1 btn btn-secondary fw-bolder col-2"
                      target="_blank"
                      disabled={
                        proj?.math_connection == null &&
                        proj?.ela_connection == null &&
                        proj?.sse == null &&
                        proj?.about_school == null &&
                        proj?.engandtech == null
                      }
                      href={`${BASE_URL}/previewip.php?id=${res.data.data.hashes[key]}`}
                    >
                      Preview
                    </a>
                  </div>
                </>
              ),
            };
          });
          Swal.close();
          return { ...newState, rows: newRows };
        });
      } catch {}
    })();
  }, []);


  const handleDescModal = async (proj) => {
    await setDescModal(true);
    setRichBox(proj.description);
    let cont = jQuery.parseHTML(proj.description);
    
    let par = document.getElementById("description");
    cont.forEach((el) => {
      par.appendChild(el);
    });
  };

  const changeHandler = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    let body = {
      title: formData.title,
      description: richBox,
      type: "individual",
    };

    try {
      let res = await axios.post(`${BASE_URL}/student/addproject.php`, body);
      await Swal.fire("Added Successfully", "", "success");
      await clearFormData();
      setDatatable((prevState) => {
        const newState = { ...prevState };
        let ser = 1;
        let newRows = res.data.data.indprojects.map((proj, key) => {
          return {
            ...proj,
            serial: ser++,
            projectid: proj.id,
            projectname: proj.name,
            controls: (
              <>
                <div className="row justify-content-start p-3">
                  <a
                    className="col-3 w-75 my-1 btn btn-info"
                    onClick={() => handleDescModal(proj)}
                  >
                    Show
                  </a>

                  <Link
                    className="col-3 w-75 my-1 btn btn-success fw-bolder col-2"
                    to={`/groupprojects/${proj.id}`}
                  >
                    Progress
                  </Link>

                  <a
                    className="col-3 w-75 my-1  btn btn-primary fw-bolder col-2"
                    onClick={(e) => handlePrefs(e, proj.id)}
                  >
                    Preferences
                  </a>

                  <a
                    className="col-3 w-75 my-1 btn btn-secondary fw-bolder col-2"
                    target="_blank"
                    disabled={
                      proj?.math_connection == null &&
                      proj?.ela_connection == null &&
                      proj?.sse == null &&
                      proj?.about_school == null &&
                      proj?.engandtech == null
                    }
                    href={`${BASE_URL}/previewip.php?id=${res.data.data.hashes[key]}`}
                  >
                    Preview
                  </a>
                </div>
              </>
            ),
          };
        });
        Swal.close();
        return { ...newState, rows: newRows };
      });
    } catch {
      await Swal.fire("Something Went Wrong", "", "error");
    }
  };

  const handlePrefs = (e, id) => {
    e.preventDefault();
    setProId(id);
    setModalPrefs(true);
  };

  const handlSelect = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setSelectedPrefs((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmitPrefs = async (e) => {
    e.preventDefault();
    let body = {
      proId: proId,
      template: selectedPrefs.template,
      bgcolor: selectedPrefs.bgcolor,
      fgcolor: selectedPrefs.fgcolor,
    };

    try {
      await axios.post(`${BASE_URL}/student/setindprojectprefs.php`, body);
      await Swal.fire("Prefrences Stored Successfully!", "", "success");
    } catch {
      await Swal.fire("Error while sending prefrences", "", "error");
    } finally {
      setModalPrefs(false);
    }
  };
  useEffect(()=>{
    getProjects();
  },[showAll])
  const getProjects = () => {
    Swal.showLoading();
    axios
      .post(`${BASE_URL}/student/getgroupprojects.php`, {
        sId: permissions.id,
        all: showAll,
      })
      .then((res) => {
        setDatatable((prevState) => {
          const newState = { ...prevState };
          let ser = 1;
          let newRows = res.data.data.groupprojects.map((proj, key) => {
            return {
              ...proj,
              serial: ser++,
              projectid: proj.id,
              projectname: proj.name,
              controls: (
                <>
                  <div className="row justify-content-start p-3">
                    <a
                      className="col-3 w-75 my-1 btn btn-info"
                      onClick={() => handleDescModal(proj)}
                    >
                      Description
                    </a>

                    <Link
                      className="col-3 w-75 my-1 btn btn-success fw-bolder col-2"
                      to={`/groupprojects/${proj.id}`}
                    >
                      Progress
                    </Link>

                    <a
                      className="col-3 w-75 my-1  btn btn-primary fw-bolder col-2"
                      onClick={(e) => handlePrefs(e, proj.id)}
                    >
                      Preferences
                    </a>

                    <a
                      className="col-3 w-75 my-1 btn btn-secondary fw-bolder col-2"
                      target="_blank"
                      disabled={
                        proj?.math_connection == null &&
                        proj?.ela_connection == null &&
                        proj?.sse == null &&
                        proj?.about_school == null &&
                        proj?.engandtech == null
                      }
                      href={`${BASE_URL}/previewip.php?id=${res.data.data.hashes[key]}`}
                    >
                      Preview
                    </a>
                  </div>
                </>
              ),
            };
          });

          return { ...newState, rows: newRows };
        });
      })
      .finally(() => {
        Swal.close();
      });
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card className="w-100">
              <CardHeader>
                <h4 className="title">Projects</h4>
              </CardHeader>
              {/* <div className="text-center">
                                    <button className="btn btn-primary fw-bolder mx-auto w-25" onClick={()=>{
                                        if (addProject == 'none') { setAddProject('block') }
                                        else { setAddProject('none') }
                                        }}>
                                        Add Project
                                    </button>
                                </div> */}
              <Row style={{ display: addProject }}>
                <Col md={12}>
                  <hr />
                  <div className="col-12">
                    <label
                      className="fs-6 ms-3 mt-3 fw-bolder text-primary"
                      htmlFor="proname"
                    >
                      Name
                    </label>
                    <br />
                    <Input
                      className="w-50 text-center fw-bolder text-info fs-5"
                      type="text"
                      name="title"
                      id="proname"
                      value={formData.title}
                      placeholder="Type project name here....."
                      style={{ height: "50px" }}
                      onChange={changeHandler}
                    />
                  </div>
                  {/* **************** test react froala editor ************* */}
                  {/* <FroalaEditor
                                            tag='textarea'
                                        /> */}

                  <div className="col-12" id="bodyarea">
                    <label className="fs-6 ms-3 mt-3 fw-bolder text-primary">
                      Description
                    </label>
                    <RichBox
                      onChange={(data)=>{setRichBox(data);}}
                    
                      defaultValue={richBox}
                      height={"10px"}
                    ></RichBox>                    
                  <div id="rich"></div>
                  </div>
                  <div className="text-center">
                    <button
                      className="btn btn-primary w-25 fw-bolder mx-auto"
                      onClick={(e) => submitHandler(e)}
                    >
                      Submit
                    </button>
                  </div>
                  <hr />
                </Col>
              </Row>
              <CardBody className="all-icons">
                <div>
                  <div className="form-check form-check-inline ">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      style={{ marginRight: "-20%" }}
                      defaultChecked={true}
                      onChange={(e) => {
                        setShowAlll("");
                      }}
                      value="option1"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Current Projects
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      style={{ marginRight: "-20%" }}
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      onChange={(e) => {
                        setShowAlll("all");
                      }}
                      id="inlineRadio2"
                      value="option2"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      Archived Projects
                    </label>
                  </div>
                </div>
                <Row>
                  <MDBDataTableV5
                    hover
                    responsive
                    bordered
                    borderless={false}
                    striped
                    entriesOptions={[5, 20, 25]}
                    entries={10}
                    pagesAmount={4}
                    data={datatable}
                    fullPagination
                    searchTop
                    searchBottom={false}
                  />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={descModal}
          size="fullscreen"
          className="custom-modal-style"
        >
          <ModalHeader className="bg-info fw-bolder">
            Project Details
          </ModalHeader>
          <ModalBody>
            {/* <div id="parent"></div> */}
            <div id="description" className="descrip text-center">
              {/* {jQuery.parseHTML(descrip)} */}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={() => setDescModal(false)}
            >
              Close
            </button>
          </ModalFooter>
        </Modal>

        {/* **********************Prefs Modal********************** */}
        <Modal isOpen={modalPrefs} size="md" className="pref-modal">
          <ModalHeader className="bg-info fw-bolder">
            Project Preferences
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={(e) => handleSubmitPrefs(e)}>
              <Label htmlFor="templ">Select Template:</Label>
              <Input
                id="templ"
                name="template"
                onChange={(e) => handlSelect(e)}
                value={selectedPrefs.template}
                type="select"
                required
              >
                <option defaultValue={true} value="Default">
                  Default
                </option>
              </Input>
              <br />
              <Label htmlFor="bgclr">Select Background-Color:</Label>
              <Input
                id="bgclr"
                name="bgcolor"
                onChange={(e) => handlSelect(e)}
                type="color"
                value={selectedPrefs.bgcolor}
              ></Input>
              <br />
              <Label htmlFor="fgclr">Select Foreground-Color:</Label>
              <Input
                id="fgclr"
                name="fgcolor"
                onChange={(e) => handlSelect(e)}
                type="color"
                value={selectedPrefs.fgcolor}
              ></Input>
              <br />
              <Input
                type="submit"
                value="submit"
                className="btn btn-primary mt-1 mx-auto fs-6 fw-bolder"
              />
            </Form>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={() => setModalPrefs(false)}
            >
              Close
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default GroupProjects;
